export const color = {
	primary: '#08101a',
	secondary: '#ffffff',
	tertiary: '#ffffff',
	headerLogo: '#08101a',
	footerBg: '#ffffff',

	blackOne: '#08101a',
	blackTwo: '#43484D',

	buttonNextBgColor: '#08101a',
	buttonNextTextColor: '#fff',
	buttonNextMobileBgColor: '#08101a',
	buttonNextMobileTextColor: '#08101a',
	buttonNextBorderColor: '#fff',
	buttonNextMobileBorderColor: '#fff',
	buttonNextHoverBgColor: '#fff',
	buttonNextHoverTextColor: '#08101a',
	buttonNextHoverBorderColor: '#08101a',

	buttonBackBgColor: '#fff',
	buttonBackTextColor: '#08101a',
	buttonBackMobileBgColor: '#fff',
	buttonBackMobileTextColor: '#08101a',
	buttonBackBorderColor: '#08101a',
	buttonBackMobileBorderColor: '#08101a',
	buttonBackHoverBgColor: '#08101a',
	buttonBackHoverTextColor: '#fff',
	buttonBackHoverBorderColor: '#08101a',

	exchangeSelectBtnTextColor: '#fa6532',
	exchangeSelectBtnBgColor: '#ffffff',
	exchangeSelectBtnBorderColor: '#fa6532',
	exchangeSelectBtnBorderSize: '2px',
	exchangeSelectBtnSVGColor: '#fa6532',

	exchangeDontSelectBtnTextColor: '#fa6532',
	exchangeDontSelectBtnBgColor: '#ffffff',
	exchangeDontSelectBtnBorderColor: '#fa6532',
	exchangeDontSelectBtnBorderSize: '2px',
	exchangeDontSelectBtnSVGColor: '#fa6532',

	exchangeRemoveSelectBtnTextColor: '#fa6532',
	exchangeRemoveSelectBtnBgColor: '#ffffff',
	exchangeRemoveSelectBtnBorderColor: '#fa6532',
	exchangeRemoveSelectBtnBorderSize: '2px',
	exchangeRemoveSelectBtnSVGColor: '#fa6532',

	flowButtonSelectedTextColor: '#ffffff',
	flowButtonSelectedBgColor: '#08101a',
	flowButtonSelectedBorderColor: '#08101a',

	flowButtonOriginalTextColor: '#08101a',
	flowButtonOriginalBgColor: '#ffffff',
	flowButtonOriginalBorderColor: '#08101a',

	grayOne: '#E6E6E6',
	grayTwo: '#f7f7f7',
	grayThree: '#666',
	grayFour: '#C4C4C4',
	grayFive: '#DCDCDC',
	graySix: '#A6A6A6',
	graySeven: '#F1F1F1',
	grayEight: '#F5F5F5',
	grayTen: '#666666',
	grayEleven: '#EDEDED',
	grayTwelve: '#E6E6E6',
	grayThirteen: '#DADADA',
	grayFourteen: '#696969',
	grayFifteen: '#E5E5E5',
	graySixteen: '#E2E2E2',
	graySeventeen: '#D3D3D3',
	grayEighteen: '#5E5E5E',
	grayNineteen: '#A1A1A1',

	greenTwo: '#D7F2EA',
	greenThree: '#D7F2EA',
	greenFour: 'rgba(45,205,178,0.2)',

	redOne: '#EA0000',
	redTwo: '#F32727',
}
